import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
import { sessionApiStore } from "@/hooks";
import { CardPage, Typography } from "@/components";


/**
 * Displays the login page.
 */
const __default__ = {
  name: "LoginView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

onMounted(() => {
  sessionApiStore.handleDemoLogin();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CardPage), { id: "login-view" }, {
    form: _withCtx(() => [
      _createVNode(_unref(Typography), { value: "Loading demo account..." })
    ]),
    _: 1
  }))
}
}

})